module.exports = __webpack_public_path__ + "static/media/Zington_Logotyp_Pos_RGB.5ef7599b.svg";